import React from 'react';

import { AnimatePresence } from 'framer-motion';

import Notification from '@pkg/components/Elements/Notification/Notification';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { deleteNotification } from '@app/store/actions/notification';

const Notifications = () => {
    const dispatch = useAppDispatch();

    const notifications = useAppSelector((state) => state.notifications);

    // only show one notification at a time, if multiple notifications are added
    // they will show up one after another like a queue
    const notificationToShow = notifications[notifications.length - 1];

    return (
        <AnimatePresence mode="wait">
            {notifications.length && (
                <Notification
                    key={notificationToShow.message}
                    notification={notificationToShow}
                    onTimeout={() => dispatch(deleteNotification(notificationToShow))}
                    onClick={() => dispatch(deleteNotification(notificationToShow))}
                />
            )}
        </AnimatePresence>
    );
};

export default Notifications;
